<button
  class="edit-field-inline-delete-button"
  mat-menu-item
  type="button"
  (click)="confirmDelete()"
>
  <span>
    {{ 'TRANS__DELETE_ITEM__DELETE' | translate }}
  </span>
</button>
